module.exports = __webpack_public_path__ + "static/img/taobao.d00b7402.png";